import InputTitle from './inputTitle';
export default InputTitle;